import React, {Component} from 'react';
import {
  BrowserRouter,
  Router,
  Route,
  Switch,
  HashRouter,
  Redirect,
} from 'react-router-dom';

import {createBrowserHistory} from 'history';
import Dashboard from '../containers/DashboardContainer';
import Licensee from '../containers/LicenseeContainer';
import Login from '../containers/LoginContainer';
import DefaultLayout from '../containers/DefaultLayout';
import Country from '../containers/CountryContainer';
import Currency from '../containers/CurrencyContainer';
import CountryCrncy from '../containers/CountryCrncyContainer';
import PaymentMode from '../containers/PaymentModeContainer';
import Unit from '../containers/UnitContainer';
import Brand from '../containers/BrandContainer';
import ForgotPassword from '../containers/FrgtPswdContainer';
import Feedback from '../containers/FeedbackContainer';
import Appversion from '../containers/AppversionContainer';
import PatientsProfile from '../containers/PatientsProfileContainer';
import PatientPayment from '../containers/PatientPaymentContainer';
import PatientInvoice from '../containers/PatientInvoiceContainer';
import ChemistProfile from '../containers/ChemistProfileContainer';
import ChemistPayment from '../containers/ChemistPaymentContainer';
import ChemistInvoice from '../containers/ChemistInvoiceContainer';
import ChemistOrderContainer from '../containers/ChemistOrderContainer';
import DistributorProfile from '../containers/DistributorProfileContainer';
//import SignUp from "../containers/SignUpContainer";
import Support from '../containers/SupportContainer';
import SupportUsers from '../containers/SupportUsersContainer';
import PatientsOrder from '../containers/PatientsOrderContainer';
import ProductReturns from '../containers/ProductReturnsContainer';
import CreditNotes from '../containers/CreditNotesContainer';
import PlatformEarnings from '../screens/PlatformEarnings';
import ItemCategory from '../containers/ItemCategoryContainer';
import SupportType from '../containers/SupportTypeContainer';
import ItemMaster from '../containers/ItemMasterContainer';
import DeliveryStatusContainer from '../containers/DeliveryStatusContainer';
import State from '../containers/StateContainer';
import District from '../containers/DistrictContainer';
import TermsandCondition from '../containers/TermsandConditionContainer';
import Helpline from '../containers/HelplineContainer';
import Bank from '../containers/BankContainer';
import Cpvalue from '../containers/CpvalueContainer';
/*import location from "../containers/LocationContainer";
import Category from "../containers/CategoryContainer";
import Subcategory from "../containers/SubcategoryContainer";*/

var history = createBrowserHistory();

const PrivateRoute = ({component: Component, ...rest}) =>
  <Route
    {...rest}
    render={props =>
      localStorage.getItem('userdata')
        ? <Component {...props} />
        : <Redirect to="/login" />}
  />;

function AppNavigator() {
  return (
    <Switch>
      <Route path="/dashboard" name="Dashboard" component={DefaultLayout} />
      ,
      <Route path="/dashboard/licensee" name="Licensee" component={Licensee} />
      ,
      <Route path="/login" name="Login" component={Login} />
      ,
      <Route
        path="/dashboard/patientusers/patientsprofile"
        name="Patient Profiles"
        component={PatientsProfile}
      />
      ,
      <Route
        path="/dashboard/patientusers/patientPayment"
        name="patientPayment"
        component={PatientPayment}
      />
      ,
      <Route
        path="/dashboard/patientusers/patientInvoice"
        name="patientInvoice"
        component={PatientInvoice}
      />
      ,
      <Route
        path="/dashboard/chemistuser/chemistprofile"
        name="Chemist Profiles"
        component={ChemistProfile}
      />
      ,
      <Route
        path="/dashboard/chemistuser/chemistPayment"
        name="chemistPayment"
        component={ChemistPayment}
      />
      ,
      <Route
        path="/dashboard/chemistuser/chemistInvoice"
        name="chemistInvoice"
        component={ChemistInvoice}
      />
      ,
      <Route
        path="/dashboard/chemistuser/chemistorders"
        name="Chemist Orders"
        component={ChemistOrderContainer}
      />
      ,
      <Route
        path="/dashboard/distributors"
        name="Profile"
        component={DistributorProfile}
      />
      ,
      <Route
        path="/dashboard/settings/country"
        name="Countries"
        component={Country}
      />
      ,
      <Route
        path="dashboard/settings/currency"
        name="Currency"
        component={Currency}
      />
      ,
      <Route
        path="/dashboard/settings/countryCrncy"
        name="Country Currency"
        component={CountryCrncy}
      />
      ,
      <Route path="/dashboard/settings/unit" name="Unit" component={Unit} />
      ,
      <Route
        path="/dashboard/settings/paymentmode"
        name="PaymentMode"
        component={PaymentMode}
      />
      ,
      <Route
        path="/dashboard/settings/itemCategory"
        name="ItemCategory"
        component={ItemCategory}
      />
      ,
      <Route path="/dashboard/settings/brand" name="Brand" component={Brand} />
      ,
      <Route path="/dashboard/feedback" name="Feedback" component={Feedback} />
      ,
      <Route
        path="/dashboard/appversion"
        name="Appversion"
        component={Appversion}
      />
      ,
      {/* <Route path="/signup" name="SignUp" component={SignUp} />
      , */}
      <Route
        path="/forgotpassword"
        name="ForgotPassword"
        component={ForgotPassword}
      />{' '}
      ,
      <Route path="/" name="Dashboard" component={DefaultLayout} />,
      <Route
        path="/dashboard/patientusers/patientorder"
        name="Patient Orders"
        component={PatientsOrder}
      />{' '}
      ,
      <Route
        path="/productreturns"
        name="Product Returns"
        component={ProductReturns}
      />
      ,
      <Route path="/creditnotes" name="Credit Notes" component={CreditNotes} />,
      <Route
        path="/platformearnings"
        name="Platform Earnings"
        component={PlatformEarnings}
      />
      ,
      <Route path="/support" name="Support" component={Support} />
      ,
      <Route
        path="/supportUsers"
        name="Support Users"
        component={SupportUsers}
      />
      ,
      <Route path="/itemmaster" name="Item Master" component={ItemMaster} />,
      {/*<Route
        path="/dashboard/settings/location"
        name="Location"
        component={location}
      />,
      <Route
        path="/dashboard/settings/category"
        name="Category"
        component={Category}
      />,
      <Route
        path="/dashboard/settings/subcategory"
        name="Subcategory"
        component={Subcategory}
      />,
       */}
      <Route
        path="/dashboard/settings/district"
        name="District"
        component={District}
      />
      ,
      <Route
        path="/dashboard/settings/supportType"
        name="Support Type"
        component={SupportType}
      />
      ,
      <Route path="/dashboard/settings/state" name="State" component={State} />,
      <Route
        path="/dashboard/settings/deliveryStatus"
        name="Delivery Status"
        component={DeliveryStatusContainer}
      />
      ,
      <Route
        path="/dashboard/settings/Cpvalue"
        name="CP Value"
        component={Cpvalue}
      />
      ,
      <Route
        path="/dashboard/settings/helpline"
        name="Helpline"
        component={Helpline}
      />
      ,
      <Route path="/dashboard/settings/bank" name="Bank" component={Bank} />
      <Route
        path="/dashboard/settings/termsandcondition"
        name="TermsandCondition"
        component={TermsandCondition}
      />
    </Switch>
  );
}
export default AppNavigator;
